import { getValue, setValue } from '../../../Util/LocalStorage';

const READ_ANNOUNCEMENTS = 'READ_ANNOUNCEMENTS';
const getKey = (username) => `${READ_ANNOUNCEMENTS}_${username}`;

export const ANNOUNCEMENT_CATEGORY = {
  COURSE: 'COURSE',
  COURSE_WITH_EMAIL: 'COURSE_WITH_EMAIL',
  COURSE_WITH_PUSH_NOTIFICATION: 'COURSE_WITH_PUSH_NOTIFICATION',
  COURSE_WITH_PUSH_NOTIFICATION_AND_EMAIL: 'COURSE_WITH_PUSH_NOTIFICATION_AND_EMAIL',
  NEWS: 'NEWS',
  REMINDER: 'REMINDER',
  CLEARS: 'QUESTION_ANSWERED',
  INTERNAL_OR_EXTERNAL_URL: 'INTERNAL_OR_EXTERNAL_URL',
};

export const COURSE_ANNOUNCEMENT_CATEGORIES = [
  ANNOUNCEMENT_CATEGORY.COURSE,
  ANNOUNCEMENT_CATEGORY.COURSE_WITH_EMAIL,
  ANNOUNCEMENT_CATEGORY.COURSE_WITH_PUSH_NOTIFICATION,
  ANNOUNCEMENT_CATEGORY.COURSE_WITH_PUSH_NOTIFICATION_AND_EMAIL,
];

export const readAnnouncement = (id, username) => {
  const key = getKey(username);
  const readIds = new Set(getValue(key));
  readIds.add(id);
  setValue(key, Array.from(readIds));
};

export const resetReadAnnouncements = (username) => {
  const key = getKey(username);
  setValue(key, []);
};

export const getUnreadCount = (announcements, username) => {
  const key = getKey(username);
  const readIds = new Set(getValue(key));
  const unread = announcements.filter((announcement) =>
    announcement.category === ANNOUNCEMENT_CATEGORY.NEWS
      ? !readIds.has(announcement.id)
      : !announcement.readAt
  );
  return unread.length;
};

export const splitTab = (dataList, t, username) => {
  const key = getKey(username);
  const readIds = new Set(getValue(key));
  const mapData = ({
    id,
    title,
    category,
    detail: { content: rawContent, type: contentType },
    announcedBy,
    publishedTime,
    courseTitle,
    courseCode,
    readAt,
    redirectUrl,
  }) => ({
    id: id,
    isNew: category === ANNOUNCEMENT_CATEGORY.NEWS ? !readIds.has(id) : !readAt,
    title: title,
    caption: t('CAPTION', { name: announcedBy, date: publishedTime }),
    announcer: announcedBy,
    publishedTime,
    rawContent,
    contentType,
    category,
    courseTitle,
    courseCode,
    redirectUrl,
  });
  const news = dataList
    .filter(
      ({ category }) =>
        category === ANNOUNCEMENT_CATEGORY.NEWS ||
        category === ANNOUNCEMENT_CATEGORY.CLEARS ||
        category === ANNOUNCEMENT_CATEGORY.INTERNAL_OR_EXTERNAL_URL
    )
    .map(mapData);
  const reminders = dataList
    .filter(({ category }) => category === ANNOUNCEMENT_CATEGORY.REMINDER)
    .map(mapData);
  const courses = dataList
    .filter(({ category }) => COURSE_ANNOUNCEMENT_CATEGORIES.includes(category))
    .map(mapData);
  return { news, reminders, courses };
};

function formatPushNotification(notification) {
  if (!notification?.data) {
    return;
  } else {
    const newNotification = {
      id: notification.data.id,
      title: notification.data.title,
      category: notification.data.category,
      announcedBy: notification.data.announcedBy,
      publishedTime: notification.data.publishedTime,
      courseCode: null,
      courseTitle: null,
      createdAt: notification.data.createdAt,
      detail: {
        content: notification.data.detail,
        type: 'HTML',
      },
      readAt: notification.data.readAt,
      redirectUrl: notification.data.redirectUrl,
    };

    return newNotification;
  }
}

export function mapNotifications(notifications) {
  return notifications.map((notification) => {
    const { id, title, content, createdAt, readAt, metadata } = notification;
    const hasRedirectUrl = Boolean(metadata?.redirectUrl);
    // NOTED: Assume that if we have redirectUrl then this notification is `INTERNAL_OR_EXTERNAL_URL`. else 'CLEAR'
    const isClearAnnouncementType = !hasRedirectUrl;

    const data = {
      id,
      title,
      category: isClearAnnouncementType
        ? ANNOUNCEMENT_CATEGORY.CLEARS
        : ANNOUNCEMENT_CATEGORY.INTERNAL_OR_EXTERNAL_URL,
      detail: content.html,
      announcedBy: isClearAnnouncementType ? 'CLEAR Admin' : 'Admin',
      publishedTime: createdAt,
      courseCode: null,
      courseTitle: null,
      createdAt,
      readAt,
      ...(!isClearAnnouncementType && { redirectUrl: metadata.redirectUrl }),
    };

    return formatPushNotification({ data });
  });
}
